/**
 * Reserves the height of the tallest panel on the product tabs.
 *
 * Without this, switching from Specifications to the longer Care or
 * Candela x CAKO text pushes everything below it down the page.
 *
 * Panels are display:none when inactive and report no height, so each one is
 * briefly laid out to measure it. That happens within a single frame, so
 * nothing is painted at the intermediate size.
 */
(function () {
  function measure(tabs) {
    var panels = tabs.querySelectorAll('.candela-tabs__panel');
    if (panels.length < 2) return;

    var tallest = 0;
    panels.forEach(function (panel) {
      var display = panel.style.display;
      var visibility = panel.style.visibility;
      panel.style.display = 'block';
      panel.style.visibility = 'hidden';
      tallest = Math.max(tallest, panel.offsetHeight);
      panel.style.display = display;
      panel.style.visibility = visibility;
    });

    tabs.style.setProperty('--candela-tabs-panel-h', tallest + 'px');
  }

  function init(root) {
    root.querySelectorAll('.candela-tabs').forEach(measure);
  }

  init(document);

  // Column width drives how the text wraps, so the tallest panel changes with it.
  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { init(document); }, 150);
  });

  // Webfonts land after first paint and change the line count.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { init(document); });
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
